import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET EXECUTIVE EMPLOYEES-----------------------------*/
export const getExecutiveEmployees = createAsyncThunk(
  "members/get-executive-employees",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}executive_employees`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
/*--------------------------GET GENERAL ASSEMBLY MEMBERS-----------------------------*/
export const getGeneralAssemblyMembers = createAsyncThunk(
  "members/get-general-assembly-members",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}general_assembly_members`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
/*--------------------------GET BOARD DIRECTORS-----------------------------*/
export const getBoardDirectors = createAsyncThunk(
  "members/get-board-directors",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}board_directors`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
/*--------------------------GET FOUNDING MEMBERS-----------------------------*/
export const getFoundingMembers = createAsyncThunk(
  "members/get-founding-members",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}founding_members`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
/*--------------------------GET ORGANIZATIONAL STRUCTURE-----------------------------*/
export const getOrganizationalStructure = createAsyncThunk(
  "members/get-organizational-structure",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}organizational_structure`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
